import _classCallCheck from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { Icon } from '../icon';
import { Sidebar } from '../sidebar';
import Image from '../Image';
import { makeNavbar, makeBrand, makeBrandLink, makeCollapse, makeContent, makeToggleNavbar, makeNavbarIcons } from './mixins';
var NavbarComponent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeNavbar(props);
});
var Brand = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeBrand(props);
});
var BrandLink = styled.a(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeBrandLink(props);
});
var Collapse = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeCollapse(props);
});
var CollapseContent = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeContent(props);
});
var SidebarContent = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeContent(props);
});
var ToggleNavbar = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeToggleNavbar(props);
});
var NavbarIcon = styled(Icon)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeNavbarIcons(props);
});

var getSidebarNav = function getSidebarNav(isNavbarContentVisible, toggleNavbarContent, isMobile, hideSearchBar, children) {
  return React.createElement(Sidebar, {
    position: "left",
    visible: isNavbarContentVisible,
    handleClose: toggleNavbarContent,
    closeType: "back"
  }, React.createElement(SidebarContent, {
    hideSearchBar: hideSearchBar
  }, children && children));
};

var getCollapseNav = function getCollapseNav(isNavbarContentVisible, toggleNavbarContent, isMobile, hideSearchBar, children) {
  return React.createElement(Collapse, {
    position: "left",
    visible: isNavbarContentVisible,
    handleClose: toggleNavbarContent
  }, React.createElement(CollapseContent, {
    hideSearchBar: hideSearchBar
  }, children && children));
};

export var NavbarClass = /*#__PURE__*/function (_React$Component) {
  _inherits(NavbarClass, _React$Component);

  var _super = _createSuper(NavbarClass);

  function NavbarClass(props) {
    var _this;

    _classCallCheck(this, NavbarClass);

    _this = _super.call(this, props);

    _this.componentDidMount = function () {
      _this.setResize();

      window.addEventListener('resize', _this.setResize);
    };

    _this.setResize = function () {
      var isMobileSize = window.innerWidth < 1200;

      _this.setState({
        isMobile: isMobileSize
      });
    };

    _this.toggleMenu = function () {
      var isNavbarContentVisible = _this.state.isNavbarContentVisible;

      _this.setState({
        isNavbarContentVisible: !isNavbarContentVisible
      });
    };

    _this.closeMenu = function () {
      _this.setState({
        isNavbarContentVisible: false
      });
    };

    _this.state = {
      isMobile: true,
      isNavbarContentVisible: false
    };
    return _this;
  }

  _createClass(NavbarClass, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          logo = _this$props.logo,
          isNavbarContentVisible = _this$props.isNavbarContentVisible,
          toggleNavbarContent = _this$props.toggleNavbarContent,
          hideSearchBar = _this$props.hideSearchBar,
          callback = _this$props.callback,
          theme = _this$props.theme,
          _this$props$url = _this$props.url,
          url = _this$props$url === void 0 ? '/' : _this$props$url;
      var isMobile = this.state.isMobile;

      var redirect = function redirect(e, item) {
        e.preventDefault();
        if (callback) callback(item);
        window.location.href = item.href;
      };

      return React.createElement(NavbarComponent, null, isMobile && React.createElement(ToggleNavbar, null, React.createElement(NavbarIcon, {
        onClick: toggleNavbarContent,
        name: "icon-light-menu",
        color: theme.colors.primary.normal
      })), React.createElement(Brand, null, React.createElement(BrandLink, {
        href: url,
        onClick: function onClick(e) {
          return redirect(e, {
            content: 'Ir a Home',
            href: url
          });
        }
      }, React.createElement(Image, {
        src: "".concat(logo.src),
        width: "".concat(logo.width),
        height: "".concat(logo.height),
        alt: "".concat(logo.alt),
        className: "".concat(logo.class),
        preload: true
      }))), isMobile ? getSidebarNav(isNavbarContentVisible, toggleNavbarContent, isMobile, hideSearchBar, children) : getCollapseNav(isNavbarContentVisible, toggleNavbarContent, isMobile, hideSearchBar, children));
    }
  }]);

  return NavbarClass;
}(React.Component);
NavbarClass.propTypes = {
  isNavbarContentVisible: PropTypes.bool.isRequired,
  toggleNavbarContent: PropTypes.func.isRequired,
  hideSearchBar: PropTypes.bool,
  children: PropTypes.node.isRequired,
  logo: PropTypes.shape({
    src: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    alt: PropTypes.string,
    class: PropTypes.string,
    hide: PropTypes.bool
  }).isRequired,
  callback: PropTypes.func,
  url: PropTypes.string
};
NavbarClass.defaultProps = {
  hideSearchBar: false,
  callback: function callback() {}
};
export var Navbar = withTheme(NavbarClass);